import _default from './Header';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Header/index.js
// module id = 2704
// module chunks = 1